/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import "./customCheckbox.css";
import RopeBlue from "../../../../../Asset/icon/rope_blue.svg";
import { Form } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { getYachtInfoSellingPriceRatePlanListDetail } from "../../../../../redux/YachtInfoSellingPriceRatePlanList/YachtInfoSellingPriceRatePlanListSlice";
import { getMarinaDetail } from "../../../../../redux/centerData/CenterDataSlice";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";

const Malina = ({ malinaData, setMalinaFilter, preMarina }) => {
  const { t } = useTranslation();
  const [selectedMalina, setSelectedMalina] = useState(Array.from(preMarina));
  const todos = useSelector((state) => state);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      dispatch(getYachtInfoSellingPriceRatePlanListDetail({})),
      dispatch(getMarinaDetail({})),
    ])
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [dispatch]);

  const AllYacht = loading
    ? []
    : todos.YachtInfoSellingPriceRatePlanListSlice.YachtInfoSellingPriceRatePlanList.results.map(
      (yacht) => ({
        ...yacht,
        name_marina_en: todos.CenterDataSlice.Marina.results.find(
          (marina) => marina.id_marina === yacht.id_marina
        )?.name_marina_en,
      })
    );

  useEffect(() => {
    setMalinaFilter(selectedMalina);
  }, [selectedMalina, setMalinaFilter]);

  const handleCheckboxChange = (event) => {
    const selectedMalinaItem = event.target.value;
    setSelectedMalina((prevSelected) =>
      prevSelected.includes(selectedMalinaItem)
        ? prevSelected.filter((malina) => malina !== selectedMalinaItem)
        : [...prevSelected, selectedMalinaItem]
    );
  };

  const handleClearFilter = () => {
    setSelectedMalina([]);
  };

  return (
    <div className="d-flex flex-column align-items-center position-relative">
      <div className="mb-4">
        <div
          className="absolute-left-text"
        >
          {t("Marina")}
        </div>
        <div
          className="absolute-right-link"
        >
          <a onClick={handleClearFilter}>{t("CLEAR")}</a>
        </div>
      </div>

      <div className="mt-4 w-80-percent">
        <Form className="d-flex flex-column align-items-start">
          {loading ? (
            <div>
              <CircularProgress className="text-primary-dark" />
            </div>
          ) : (
            malinaData.map((malina) => (
              <Form.Check
                className="custom-checkbox"
                key={malina.id_marina}
                type="checkbox"
                id={malina.id_marina}
                label={
                  <div className="text-left">
                    {malina} (
                    {
                      AllYacht.filter(
                        (yacht) => yacht.name_marina_en === malina
                      ).length
                    }
                    )
                  </div>
                }
                value={malina}
                onChange={handleCheckboxChange}
                checked={selectedMalina.includes(malina)}
              />
            ))
          )}
        </Form>
      </div>

      <div>
        <img className="m-4" draggable={false} src={RopeBlue} alt="RopeBlue" />
      </div>
    </div>
  );
};

export default Malina;
